import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    content: 'Tech Vero Solutions transformed our online presence completely. Their attention to detail and technical expertise is unmatched in the UK market.',
    author: 'James Wilson',
    role: 'Director',
    company: 'London FinTech Group'
  }, {
    content: 'The team delivered our mobile app ahead of schedule and it exceeded all expectations. Professional, responsive, and a pleasure to work with.',
    author: 'Sarah Thompson',
    role: 'Marketing Manager',
    company: 'Bright Retail'
  }, {
    content: 'We needed a complex WordPress integration and they handled it flawlessly. Our site speed and conversion rates have improved significantly.',
    author: 'David Miller',
    role: 'Founder',
    company: 'Miller Logistics'
  }];
  return <section id="testimonials" className="py-24 bg-white overflow-hidden" data-id="element-159">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-162">
            What Our Clients Say
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-163"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-164">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 p-8 rounded-2xl relative border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-165">
              {/* Quote Icon */}
              <div className="absolute top-6 right-8 text-blue-100" data-id="element-166">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-167">
                  <path d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H15.017C14.4647 8 14.017 8.44772 14.017 9V11C14.017 11.5523 13.5693 12 13.017 12H12.017V5H22.017V15C22.017 18.3137 19.3307 21 16.017 21H14.017ZM5.01697 21L5.01697 18C5.01697 16.8954 5.9124 16 7.01697 16H10.017C10.5693 16 11.017 15.5523 11.017 15V9C11.017 8.44772 10.5693 8 10.017 8H6.01697C5.46468 8 5.01697 8.44772 5.01697 9V11C5.01697 11.5523 4.56925 12 4.01697 12H3.01697V5H13.017V15C13.017 18.3137 10.3307 21 7.01697 21H5.01697Z" data-id="element-168" />
                </svg>
              </div>

              <div className="flex mb-4" data-id="element-169">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-170" />)}
              </div>

              <p className="text-gray-700 mb-6 italic relative z-10 leading-relaxed" data-id="element-171">
                "{testimonial.content}"
              </p>

              <div className="flex items-center" data-id="element-172">
                <div className="h-10 w-10 rounded-full bg-navy-100 flex items-center justify-center text-navy-700 font-bold text-lg" data-id="element-173">
                  {testimonial.author.charAt(0)}
                </div>
                <div className="ml-3" data-id="element-174">
                  <p className="text-sm font-bold text-navy-900" data-id="element-175">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-176">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}